<template>
    <b-card title="Länderindizes" class="mb-3 shadow">
        <div class="table-scrollable">
                <b-table striped hover
                :items="countryindices"
                :fields="fields"
                sticky-header="500px"
                responsive="sm"
                >
                </b-table>
        </div>
    </b-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import riskService from '../../../../../services/Riskmanagement/RiskService';

export default {
    name: 'countryindicestab',
    components: {},
    props: [],
    data() {
        return {
            countryindices: [],
            selectedYear: null,
        }
    },
    created() {
        this.fetchYears();
        this.fetchCountryIndices();
    },
    methods: {
        ...mapActions({
            fetchYears: 'years/fetch',
        }),
        fetchCountryIndices() {
            this.$store.commit('loading/setLoading', true);
                riskService.listCountryIndices()
                    .then(response => {
                        this.countryindices = response.data;
                        this.$store.commit('loading/setLoading', false);
                    }).catch(error => {
                        this.$store.commit('loading/setLoading', false);
                    });
        }
    },
    computed: {
        ...mapGetters({
            hasRole: 'auth/hasRole',
            years: 'years/years'
        }),
        fields() {
            return [
                //{ key: 'ID',                        label: 'ID'                                 , sortable: true },
                { key: 'year.year',                 label: 'Jahr'                              },
                { key: 'country.country_iso_3166',  label: 'Land'                      },
                { key: 'country.country_name',      label: 'Ländername'                             , stickyColumn: true,  isRowHeader: true },
                { key: 'country_risk_sum',          label: 'Länderrisiken (Summe)'            , variant: 'info' },
                { key: 'cpi',                       label: 'CPI'                               },
                { key: 'cpi_risk',                  label: 'Bewertung CPIT'                    },
                { key: 'critw',                     label: 'Childrens Rights'                  },
                { key: 'critw_risk',                label: 'Bewertung Childrens Rights'        },
                { key: 'gsi',                       label: 'GSI'                               },
                { key: 'gsi_risk',                  label: 'Bewertung GSI'                     },
                { key: 'nsc',                       label: 'NSC'                               },
                { key: 'nsc_risk',                  label: 'Bewertung NSC'                     },
                { key: 'wjp',                       label: 'WJP'                               },
                { key: 'wjp_risk',                  label: 'BewertungWJP'                      },
                { key: 'ituc',                      label: 'ITUC'                              },
                { key: 'ituc_risk',                 label: 'Bewertung ITUC'                    },
                { key: 'hf',                        label: 'HFI'                               },
                { key: 'hf_risk',                   label: 'Bewertung HFI'                     },
                { key: 'pf',                        label: 'PFI'                               },
                { key: 'pf_risk',                   label: 'Bewertung PFI'                     },
                { key: 'humanrights_risk_sum',      label: 'Risiken Menschenrechte (Summe)'   , variant: 'info' },
                { key: 'epi',                       label: 'EPI'                               },
                { key: 'epi_risk',                  label: 'Bewertung EPI'                     },
                { key: 'environmental_risk_sum',    label: 'Umweltrisiken (Summe)'            , variant: 'info' },
                { key: 'notes',                     label: 'Details'                          , variant: 'secondary' },
            ];
        },
    },
}
</script>